/**
 * plugins/vuetify.js
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import colors from 'vuetify/util/colors'

// Composables
import { createVuetify } from 'vuetify'
import { createVueI18nAdapter } from 'vuetify/locale/adapters/vue-i18n'
import i18n from './i18n'
import syftIcons from '@/styles/syftIcons'

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides

export default createVuetify({
  icons: {
    syftIcons: syftIcons
  },
  locale: {
    adapter: createVueI18nAdapter({ i18n })
  },
  defaults: {
    VTextField: {
      density: 'compact'
    },
    VSelect: {
      density: 'compact'
    },
    VList: {
      density: 'compact',
      nav: true
    },
    VListItem: {
      rounded: 'xl'
    },
    VBtn: {
      rounded: 'xl',
      size: 'small'
    }
  },
  theme: {
    defaultTheme: 'system',
    themes: {
      light: {
        colors: {
          primary: '#1e88e5', // Your primary color
          secondary: colors.purple.lighten2, // Accessing color from Vuetify's color utility
          discover: '#7C3AED'
          // Add other overrides here
        }
      },
      dark: {
        colors: {
          primary: '#1e88e5', // Your primary color for dark theme
          secondary: colors.purple.lighten2, // Accessing color from Vuetify's color utility for dark theme
          discover: '#B794F6'
          // Add other overrides here
        }
      }
    }
  }
})
